import { makeVar } from '@apollo/client';

export enum EAppTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

interface IThemeProps {
  name: EAppTheme;
}

export const themeVar = makeVar<IThemeProps>({
  name: EAppTheme.LIGHT,
});
